
import Paging from '@/components/Table/Paging'

export default {
  components: {
    Paging
  },
  props: {
    screen:{
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      url: {
        list: SZH.assets.api + '/Custom/GetPagingWorkOrders',
        WorkOrderSumbit: SZH.assets.api + '/Custom/WorkOrderSumbit',//提交工单
        WorkOrderInfoSumbit: SZH.assets.api + '/Custom/WorkOrderInfoSumbit',//工单回复
        GetWorkOrderForm: SZH.assets.api + '/Custom/GetWorkOrderForm',//获取表单信息
        GetWorkOrderList: SZH.assets.api + '/Custom/GetWorkOrderList',//获取回复列表
      },
      loading:true,
      queryParams: {
        keyWord:''
      },
      dialogFormVisible:false,
      form:{
        F_Id:'',
        F_Title:'',
        F_Content:'',
        F_Creator:'',
        F_CreateTimeStr:''
      },
      replay:{
        F_Message:'',
        F_OrderId:''
      },
      isEdit:false,
      fullscreenLoading:false,
      meLoading:false,
      replayList:[],
      connection:null,
      hubProxy:null,
      canSend:false,
    }
  },
  methods: {
    goBack(){
      this.$router.push({
        path: '/My/UserInfo'
      })
    },
    submitWork(){
      let self = this;
      if(!self.form.F_Title){
        self.$message.error('请输入主题！');
        return
      }
      if(!self.form.F_Content){
        self.$message.error('请输入内容！');
        return
      }
      self.fullscreenLoading = true;
      self.$http.post(self.url.WorkOrderSumbit,self.form)
        .then(result => {
          if (result.state == true) {
            self.$message.success('提交成功');
            self.dialogFormVisible = false;
            self.fullscreenLoading = false;
            self.search();
          } else {
            self.fullscreenLoading = false;
            self.$message.error(result.message);
          }

        }, () => {
          self.fullscreenLoading = false;
          // 请求失败
          self.$message.error('登录失败，请检查您的网络是否可用。');
        });
    },
    add(){
      this.form.F_Title = '';
      this.form.F_Content = '';
      this.dialogFormVisible = true;
    },
    onEdit(row){
      let self = this;
      self.$router.push({
        path: '/Notice',
        query:{
          id:row.F_Id
        }
      })

    },
    search(){
      this.loading = true;
      this.$refs['paging'].reload();
    },
    onLoaded() {
      this.loading = false
    }
  },
  computed: {

  },
  created() {
  },
  mounted() {


  },
  watch: {
  }
}



// WEBPACK FOOTER //
// ./src/views/NoticeList/NoticeList.js